import {Injectable} from '@angular/core';

@Injectable()
export class PreviousSearchesBurgerService {

    public previousSearchBurger = false;

    constructor() { }

  closePreviousSearchesBurger() {
    this.previousSearchBurger = false;
  }

}
